<br><br>
<div id="campo" [ngClass]="this.TipoPantalla=='LISTADO' ? 'campo campo-sm' : '' " *ngIf="this.form_template">

  <!-- BEGIN MODAL -->
  <ng-template #contenido let-modal>
    <div class="modal-header">
      <h4 class="modal-title"></h4>
      <button type="button" class="btn-close btn-rounded" data-bs-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <app-advancedtable [WsURL]=strWsURLModal [WsLlaves]=WsLlavesModal (RetornoModal)=RetornoModal($event)
        [mostrarModal]=true [WsFiltroModal]=WsFiltroModal [SYS02CON_PAPA_MODAL]=this.SYS02CON_PAPA_MODAL>
      </app-advancedtable>
    </div>
  </ng-template>
  <!-- END MODAL -->
  <div *ngIf="Mostrartitulofiltro == false">
    <div id="buttons" *ngIf="this.ToolbarMS">
      <!-- BEGIN Toolbar -->
      <div class="row">
        <div class="col-12">
          <div class="navbar-header toolbar">
            <div class="d-flex"></div>
            <div class="d-flex">
              <div class="d-inline-block bloque" *ngFor="let boton of this.ToolbarMS">
                <button type="button" title="{{boton.Tooltip}}" Style="margin-left: 10px" id="campo_{{boton.Evento}}" *ngIf="boton.Evento != 'IMPRIMIR' && boton.Evento != 'ABRIR_MS'"
                  name="{{boton.Evento}}"
                  (click)="EventoClickMS($event, boton.URL, boton.Evento,'campo_'+boton.Evento,boton, '')"
                  class="btn  blanco  btn-label waves-light" [ngStyle]="{'background-color': boton.class }">
                  <i class="fas {{ boton.icono }}  label-icon" style="pointer-events:none ;"></i>
                  {{boton.boton}}
                </button>

                <div ngbDropdown class="d-inline-block" *ngIf="boton.Evento == 'IMPRIMIR' && boton.Evento != 'ABRIR_MS'">
                  <button type="button" title="{{boton.Tooltip}}" Style="margin-left: 10px" id="campo_{{boton.Evento}}"
                    ngbDropdownToggle
                    name="{{boton.Evento}}"
                    class="btn  blanco  btn-label waves-light" [ngStyle]="{'background-color': boton.class }">
                    <i class="fas {{ boton.icono }}  label-icon" style="pointer-events:none ;"></i>
                    {{boton.boton}}
                  </button>
                  <div ngbDropdownMenu>
                  <ng-container>
                      <button ngbDropdownItem id="PDF" name="PDF" (click)="EventoClickMS($event, boton.URL, boton.Evento, 'campo_'+boton.Evento, boton, 'PDF')">
                          <i class="fas fa-file-pdf label-icon operacion-pdf" >
                          </i> 
                          Ver en PDF
                      </button>
                      <button ngbDropdownItem id="EXCEL" name="EXCEL" (click)="EventoClickMS($event, boton.URL, boton.Evento, 'campo_'+boton.Evento, boton, 'XLS')">
                          <i class="fas fa-file-excel label-icon operacion-excel" >
                          </i> 
                          Descargar Excel
                      </button>
                  </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END Toolbar -->
  <!-- BEGIN TITULO FILTROS PARA LAS LISTAS -->
  <div class="search-box" *ngIf="Mostrartitulofiltro == true">
    <strong class="text-muted">Digite filtro deseado:</strong>
    <hr class="my-4">
  </div>
  <!-- FIN TITULO FILTROS PARA LAS LISTAS -->

  <!-- BEGIN FORMULARIO -->

  <form [formGroup]="this.myFormGroup" (submit)="ValidarFormulario()" class="mt-3" style="margin-left: 1em; margin-right: 1em;">

    <div ngbAccordion [destroyOnHide]="false">
      <ng-container *ngFor="let form_cards of form_template">
        <div ngbAccordionItem [collapsed]="form_cards.abierto != 'S'">
          <h5 ngbAccordionHeader>
            <button ngbAccordionButton>{{form_cards.descripcion}}</button>
          </h5>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody style="background-color: white;">
              <ng-template>
                <div class="container-fluid">
                  <div class="row">
                    <ng-container *ngFor="let form_elem of form_cards.cards;let indice = index">

                      <ng-container [ngSwitch]="form_elem.type">
          
                        <ng-container *ngSwitchCase="'textbox_modal'">
                          <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-sm-12 col-md-12' : 'col-md-6'">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                              <label for="{{form_elem.label}}"
                                [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-4 col-form-label' : 'col-md-3 col-form-label'"
                                (click)="AbrirModal(contenido, form_elem)" style="text-decoration: underline; cursor: pointer;">
                                {{form_elem.title}}
                                <span *ngIf="form_elem.validators.required">(*)</span>
                              </label>
                              <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-12' : 'col-sm-9'">
                                <input type="text" class="form-control" id="{{this.FormID}}{{form_elem.label}}"
                                  name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                  (change)="CboClick(form_elem)" formControlName="{{form_elem.label}}"
                                  [readonly]="form_elem.A04MOD == 'N'">
                                <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                <div *ngIf="form_elem.validators.required">
                                  <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                                    {{form_elem.validators.msg_validacion}}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'icono'">
                          <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-sm-12 col-md-12' : 'col-md-6'">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                              <label for="{{form_elem.label}}"
                                [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-4 col-form-label' : 'col-md-3 col-form-label'">{{form_elem.title}}
                                <span *ngIf="form_elem.validators.required">(*)</span>
                              </label>
                              <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-12' : 'col-sm-6'">
                                <input type="text" class="form-control " id="{{this.FormID}}{{form_elem.label}}"
                                  (change)="SelectIcons($event,form_elem)" name="{{form_elem.label}}"
                                  placeholder="{{form_elem.placeholder}}"
                                  [readonly]="form_elem.disabled=='S' || form_elem.A04MOD == 'N'"
                                  formControlName="{{form_elem.label}}">
                                <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                <div *ngIf="form_elem.validators.required">
                                  <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                                    {{form_elem.validators.msg_validacion}}
                                  </span>
                                </div>
                              </div>
                              <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-12' : 'col-sm-2'">
                                <i class="fas {{form_elem.value}} label-icon fa-xl" style="pointer-events:none ;"></i>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'textbox'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                              <label for="{{form_elem.label}}"
                                [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-4 col-form-label' : 'col-md-3 col-form-label'">{{form_elem.title}}
                                <span *ngIf="form_elem.validators.required">(*)</span>
                              </label>
                              <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-12' : 'col-sm-9'">
                                <input type="text" class="form-control " id="{{this.FormID}}{{form_elem.label}}"
                                  (change)="Select_ocultar(form_elem, $event)" name="{{form_elem.label}}"
                                  placeholder="{{form_elem.placeholder}}"
                                  [readonly]="form_elem.disabled=='S' || form_elem.A04MOD == 'N'"
                                  formControlName="{{form_elem.label}}">
                                <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                <div *ngIf="form_elem.validators">
                                  <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['maxlength'] ">
                                      {{form_elem.title}} No puede tener mas de {{form_elem.A03LON}} caracteres..
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['required']">
                                      {{form_elem.validators.msg_validacion}}
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['minlength']">
                                      {{form_elem.title}} debe tener al menos 1 caracter..
                                    </div>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'email'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                              <label for="{{form_elem.label}}"
                                [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-4 col-form-label' : 'col-md-3 col-form-label'">{{form_elem.title}}
                                <span *ngIf="form_elem.validators.required">(*)</span>
                              </label>
                              <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-12' : 'col-sm-9'">
                                <input type="text" class="form-control " id="{{this.FormID}}{{form_elem.label}}"
                                  name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                  [readonly]="form_elem.disabled=='S' || form_elem.A04MOD == 'N'"
                                  formControlName="{{form_elem.label}}">
                                <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                <div *ngIf="form_elem.validators">
                                  <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['maxlength'] ">
                                      {{form_elem.title}} No puede tener mas de {{form_elem.A03LON}} caracteres..
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['required']">
                                      {{form_elem.validators.msg_validacion}}
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['minlength']">
                                      {{form_elem.title}} debe tener al menos 1 caracter..
                                    </div>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
          
                        <ng-container *ngSwitchCase="'password'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                              <label for="{{form_elem.label}}"
                                [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-4 col-form-label' : 'col-md-3 col-form-label'">{{form_elem.title}}
                                <span *ngIf="form_elem.validators.required">(*)</span>
                              </label>
                              <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-12' : 'col-sm-8 '" class="password">
                                <input [type]="form_elem.tipo" class="form-control " id="{{this.FormID}}{{form_elem.label}}"
                                  name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                  [readonly]="form_elem.disabled=='S' || form_elem.A04MOD == 'N'"
                                  formControlName="{{form_elem.label}}">
          
                                <button class="btn btn-light ms-0" type="button" (click)="contrasena(form_elem)">
                                  <i class="mdi mdi-eye-outline"></i> </button>
          
                                <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                <div *ngIf="form_elem.validators.required">
                                  <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                                    {{form_elem.validators.msg_validacion}}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'textbox_date'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                              <label for="{{form_elem.label}}"
                                [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-4 col-form-label' : 'col-md-3 col-form-label'">{{form_elem.title}}
                                <span *ngIf="form_elem.validators.required">(*)</span>
                              </label>
                              <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-12' : 'col-sm-9'">
                                <input type="date" class="form-control" id="{{this.FormID}}{{form_elem.label}}"
                                  name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                  formControlName="{{form_elem.label}}" (blur)="Select_ocultar(form_elem)"
                                  [readonly]="form_elem.disabled=='S' || form_elem.A04MOD == 'N'">
                                <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                <div *ngIf="form_elem.validators">
                                  <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['maxlength'] ">
                                      {{form_elem.title}} No puede tener mas de {{form_elem.A03LON}} caracteres..
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['pattern'] ">
                                      {{form_elem.title}} no puede ser de un año con más de 4 digitos
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['required']">
                                      {{form_elem.validators.msg_validacion}}
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['minlength']">
                                      {{form_elem.title}} debe tener al menos 1 caracter..
                                    </div>
                                  </span>
                                </div>
          
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'color'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                              <label
                                [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-4 col-form-label' : 'col-md-3 col-form-label'">{{form_elem.title}}
                                <span *ngIf="form_elem.validators.required">(*)</span>
                              </label>
                              <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-12' : 'col-sm-9'">
                                <input type="color" name="{{form_elem.label}}" formControlName="{{form_elem.label}}"
                                  [(ngModel)]="form_elem.value" class="form-control form-control-sm form-control-color mw-100"
                                  [readonly]="form_elem.disabled=='S' || form_elem.A04MOD == 'N'"
                                  id="{{this.FormID}}{{form_elem.label}}" placeholder="{{form_elem.placeholder}}">
                                <label> {{form_elem.value}}</label>
                                <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                <div *ngIf="form_elem.validators.required">
                                  <span
                                    *ngIf="this.myFormGroup.controls[form_elem.label].invalid || this.myFormGroup.controls[form_elem.label].errors"
                                    class="alert-requerido">
                                    {{form_elem.validators.msg_validacion}}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'number'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                              <label
                                  [ngClass]="form_elem.SYS03TXT == 'S' ? 'label-proporcional col-form-label' : 'col-md-3 col-form-label'">
                                  {{form_elem.title}}
                                  <span *ngIf="form_elem.validators.required">(*)</span>
                                </label>
                                <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col' : 'col-sm-9'">
                                <input type="text" class="form-control form-control-sm" id="{{this.FormID}}{{form_elem.label}}"
                                  (change)="Select_ocultar(form_elem, $event)" placeholder="{{form_elem.placeholder}}"
                                  [allowNegativeNumbers]="true" formControlName="{{form_elem.label}}" mask="separator.2"
                                  thousandSeparator="," [readonly]="form_elem.disabled=='S' || form_elem.A04MOD == 'N'">
                                <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                <div *ngIf="form_elem.validators">
                                  <span
                                    *ngIf="this.myFormGroup.controls[form_elem.label].invalid || this.myFormGroup.controls[form_elem.label].errors"
                                    class="alert-requerido">
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['maxlength']">
                                      {{form_elem.title}} No puede tener mas de {{form_elem.A03LON}} caracteres..
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['required']">
                                      {{form_elem.validators.msg_validacion}}
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['minlength']">
                                      {{form_elem.title}} debe tener al menos 1 caracter..
                                    </div>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'telephone'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                              <label
                                [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-4 col-form-label' : 'col-md-3 col-form-label'">{{form_elem.title}}
                                <span *ngIf="form_elem.validators.required">(*)</span>
                              </label>
                              <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-12' : 'col-sm-9'">
                                <input type="text" class="form-control form-control-sm" id="{{this.FormID}}{{form_elem.label}}"
                                  (change)="Select_ocultar(form_elem)" placeholder="{{form_elem.placeholder}}"
                                  formControlName="{{form_elem.label}}" mask="+0*" thousandSeparator=","
                                  [readonly]="form_elem.disabled=='S' || form_elem.A04MOD == 'N'">
                                <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                <div *ngIf="form_elem.validators">
                                  <span
                                    *ngIf="this.myFormGroup.controls[form_elem.label].invalid || this.myFormGroup.controls[form_elem.label].errors"
                                    class="alert-requerido">
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['maxlength']">
                                      {{form_elem.title}} No puede tener mas de {{form_elem.A03LON}} caracteres..
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['required']">
                                      {{form_elem.validators.msg_validacion}}
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['minlength']">
                                      {{form_elem.title}} debe tener al menos 1 caracter..
                                    </div>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'select_multiple'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                              <label
                                  [ngClass]="form_elem.SYS03TXT == 'S' ? 'label-proporcional col-form-label' : 'col-md-3 col-form-label'">
                                  {{form_elem.title}}
                                  <span *ngIf="form_elem.validators.required">(*)</span>
                                </label>
                                <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col' : 'col-sm-9'">
                                <ng-select formControlName="{{form_elem.label}}" id="{{this.FormID}}{{form_elem.label}}"
                                  [(ngModel)]="form_elem.value" [readonly]="form_elem.disabled=='S' || form_elem.A04MOD == 'N'"
                                  [items]="form_elem.options" (search)="cargarCombo($event, form_elem)" bindLabel="text"
                                  bindValue="value" multiple="true">
                                </ng-select>
                                <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                <div *ngIf="form_elem.validators.required">
                                  <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                                    {{form_elem.validators.msg_validacion}}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'select'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                                <label
                                  [ngClass]="form_elem.SYS03TXT == 'S' ? 'label-proporcional col-form-label' : 'col-md-3 col-form-label'">
                                  {{form_elem.title}}
                                  <span *ngIf="form_elem.validators.required">(*)</span>
                                </label>
                                <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col' : 'col-sm-9'">
                                <ng-select formControlName="{{form_elem.label}}" id="{{this.FormID}}{{form_elem.label}}"
                                  [(ngModel)]="form_elem.value" (search)="cargarCombo($event, form_elem)"
                                  (change)="CboClick(form_elem)" [readonly]="form_elem.disabled=='S' || form_elem.A04MOD == 'N'"
                                  [items]="form_elem.options" bindLabel="text" bindValue="value">
                                </ng-select>
                                <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                <div *ngIf="form_elem.validators">
                                  <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['maxlength'] ">
                                      {{form_elem.title}} No puede tener mas de {{form_elem.A03LON}} caracteres..
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['required']">
                                      {{form_elem.validators.msg_validacion}}
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['minlength']">
                                      {{form_elem.title}} debe tener al menos 1 caracter..
                                    </div>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'ckeditor'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row">
                              <label
                                [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-4 col-form-label' : 'col-md-3 col-form-label'">{{form_elem.title}}
                                <span *ngIf="form_elem.validators.required">(*)</span>
                              </label>
                              <div class="col-md-12">
                                <ckeditor [editor]="Editor" [(ngModel)]="form_elem.value" formControlName="{{form_elem.label}}"
                                 (ready)="onReady($event, (form_elem.disabled=='S' || form_elem.A04MOD == 'N'))">
                                </ckeditor>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'cmodel_json'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row">
                              <label
                                [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-4 col-form-label' : 'col-md-3 col-form-label'">{{form_elem.title}}
                                <span *ngIf="form_elem.validators.required">(*)</span>
                              </label>
                              <div class="col-12">
                                <ngx-codemirror [(ngModel)]="form_elem.value" formControlName="{{form_elem.label}}" [options]="{
                                    lineNumbers: true,
                                    theme: 'material',
                                    mode: 'application/json'
                                  }"></ngx-codemirror>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'cmodel_sql'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row">
                              <label
                                [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-4 col-form-label' : 'col-3 col-form-label'">{{form_elem.title}}
                                <span *ngIf="form_elem.validators.required">(*)</span>
                              </label>
                              <div class="col-2">
                                <button type="button" (click)="ejecutarSQL(form_elem)" class="btn btn-sm btn-success"> <i
                                    class="fa fa-play"></i> Ejecutar</button>
                              </div>
                              <div class="col-12">
                                <ngx-codemirror [(ngModel)]="form_elem.value" formControlName="{{form_elem.label}}"
                                  [options]="opcionesSQL"></ngx-codemirror>
                              </div>
                            </div>
                          </div>
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row">
                              <div class="col-12">
                                <label class="col-form-label">Vista previa: Máximo 10 filas y 10 columnas</label>
                              </div>
                              <div class="col-12">
                                <div class="table-responsive">
                                  <table class="table table-striped" style="border: 1px solid black">
                                    <tr>
                                      <th *ngFor="let encabezado of form_elem.encabezados"> {{encabezado}}</th>
                                    </tr>
                                    <tr *ngFor="let fila of form_elem.filas">
                                      <td *ngFor="let item of fila">{{item}}</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
          
                        <ng-container *ngSwitchCase="'dropzone'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                              <label
                                [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-4 col-form-label' : 'col-md-3 col-form-label'">{{form_elem.title}}
                                <span *ngIf="form_elem.validators.required">(*)</span>
                              </label>
                              <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-12' : 'col-sm-9'">
                                <ngx-dropzone (change)="onSelect($event, form_elem)">
                                  <ngx-dropzone-label>Arrastrar y soltar</ngx-dropzone-label>
                                  <ngx-dropzone-preview *ngFor="let f of form_elem.files" [removable]="true"
                                    (removed)="onRemove(f, form_elem)">
                                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                                  </ngx-dropzone-preview>
                                </ngx-dropzone>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'textarea'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                              <label
                                  [ngClass]="form_elem.SYS03TXT == 'S' ? 'label-proporcional col-form-label' : 'col-md-3 col-form-label'">
                                  {{form_elem.title}}
                                  <span *ngIf="form_elem.validators.required">(*)</span>
                                </label>
                                <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col' : 'col-sm-9'">
                                <textarea name="{{form_elem.name}}" class="form-control" id="{{this.FormID}}{{form_elem.label}}"
                                  placeholder="{{form_elem.placeholder}}" formControlName="{{form_elem.label}}" rows="5"
                                  [readonly]="form_elem.disabled=='S' || form_elem.A04MOD == 'N'">
                                        </textarea>
                                <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                <div *ngIf="form_elem.validators">
                                  <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['maxlength'] ">
                                      {{form_elem.title}} No puede tener mas de {{form_elem.A03LON}} caracteres..
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['required']">
                                      {{form_elem.validators.msg_validacion}}
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['minlength']">
                                      {{form_elem.title}} debe tener al menos 1 caracter..
                                    </div>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
          
                        <ng-container *ngSwitchCase="'checkbox'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="form-check form-switch form-switch-md mb-2">
                              <input type="checkbox" id="{{this.FormID}}{{form_elem.label}}" class="form-check-input"
                                (change)="Select_ocultar(form_elem, $event)" placeholder="{{form_elem.placeholder}}"
                                formControlName="{{form_elem.label}}">
                              <label class="form-check-label " id="{{this.FormID}}{{form_elem.label}}"
                                for="{{form_elem.label}}">{{form_elem.title}}</label>
                            </div>
                          </div>
                        </ng-container>
          
          
          
                        <ng-container *ngSwitchCase="'radio'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row">
                              <label class="col-md-3 col-form-label">{{form_elem.title}}
                                <span *ngIf="form_elem.validators.required">(*)</span>
                              </label>
                              <div class="col-sm-8">
                                <span class="d-inline-block bloque" *ngFor="let option of form_elem.options">
                                  <input type="radio" name="{{form_elem.name}}" value="{{option.value}}"
                                    id="{{this.FormID}}{{form_elem.label}}" formControlName="{{form_elem.label}}"
                                    class="form-radio-outline" (change)="Select_ocultar(form_elem, $event)">
                                  {{option.text}}
                                </span>
                                <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                <div *ngIf="form_elem.validators.required">
                                  <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                                    {{form_elem.validators.msg_validacion}}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
          
                        <ng-container *ngSwitchCase="'select_url'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                              <label *ngIf="form_elem.disabled == 'N';else desactivado" for="{{form_elem.label}}"
                                [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-4 col-form-label' : 'col-md-3 col-form-label'"
                                (click)="AbrirModal(contenido,form_elem)" style="text-decoration: underline; cursor: pointer;">
                                {{form_elem.title}}
                                <span *ngIf="form_elem.validators.required">(*)</span>
                              </label>
                              <ng-template #desactivado>
                                <label for="{{form_elem.label}}"
                                  [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-4 col-form-label' : 'col-md-3 col-form-label'">
                                  {{form_elem.title}}
                                  <span *ngIf="form_elem.validators.required">(*)</span>
                                </label>
                              </ng-template>
                              <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-sm-12 col-md-12' : 'col-md-5'">
          
                                <input type="text" class="form-control" id="{{this.FormID}}{{form_elem.label}}"
                                  name="{{form_elem.label}}"
                                  (change)="SelectURL_Change(form_elem, $event, null);Select_ocultar(form_elem)"
                                  placeholder="{{form_elem.placeholder}}" formControlName="{{form_elem.label}}"
                                  [readonly]="form_elem.disabled=='S' || form_elem.A04MOD == 'N'"
                                  [ngStyle]="{'background-color':form_elem.disabled === 'N'?'':'#eff2f7' }">
                                <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                <div *ngIf="form_elem.validators">
                                  <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['maxlength'] ">
                                      {{form_elem.title}} No puede tener mas de {{form_elem.A03LON}} caracteres..
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['required']">
                                      {{form_elem.validators.msg_validacion}}
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['minlength']">
                                      {{form_elem.title}} debe tener al menos 1 caracter..
                                    </div>
                                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['pattern']">
                                      {{form_elem.title}} debe ser númerico
                                    </div>
                                  </span>
                                </div>
                              </div>
          
                              <div class="col-md-4" *ngIf="form_elem.SYS03CDE">
                                <span [textContent]="form_elem.labeldes"></span>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'espacio'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-sm-12 col-md-12' : 'col-md-6'"> </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'titulo'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <h4 [ngClass]="blnMostrarBusqueda ? '' : 'card-title mb-2'">{{form_elem.title}}</h4>
                          </div>
                        </ng-container>
          
          
                        <ng-container *ngSwitchCase="'span'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                              <label
                                [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-4 col-form-label' : 'col-md-3 col-form-label'">{{form_elem.title}}</label>
                              <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-12' : 'col-sm-9'">
                                <input type="text" class="form-control" id="{{this.FormID}}{{form_elem.label}}"
                                  name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                  formControlName="{{form_elem.label}}" readonly>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'visor_pdf'">
                          <div class="col-12">
                            <div class="mb-2 row">
                              <ng-container *ngIf="form_elem.ArchivoBase64 != ''">
                                <div *ngIf="visor(form_elem);else noVisor" class="col-md-12">
                                  <report-viewer [ReportData]="form_elem.ArchivoBase64"
                                    [tipoDocumento]="form_elem.tipoDocumento"></report-viewer>
                                </div>
                                <ng-template #noVisor>
                                  <div class="col-6">
                                    <button (click)="visorDescargar(form_elem)" type="button" class="btn btn-lg btn-primary"><i
                                        class="fa fa-download"></i> Descargar</button>
                                    {{form_elem.value}}
                                  </div>
                                </ng-template>
                              </ng-container>
                            </div>
                          </div>
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'hidden'">
                          <input type="hidden" class="form-control" id="hide_{{this.FormID}}{{form_elem.label}}"
                            name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                            formControlName="{{form_elem.label}}">
                        </ng-container>
          
                        <ng-container *ngSwitchCase="'fotografia'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="col-md-12">
                              <div class="foto-thumbnail-container position-relative mb-3" (click)="openModal(form_elem.label)">
                                <img [src]="strFOTOMap[form_elem.label] || 'assets/placeholder.gif'" alt="Foto" class="foto-thumbnail" />
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        
                        <!-- Modal para imagen ampliada -->
                        <div class="modal-backdrop" *ngIf="modalOpen" (click)="closeModal()">
                          <div class="modal-content" (click)="$event.stopPropagation()">
                            <img [src]="strFOTOMap[modalLabel] || 'assets/placeholder.gif'" alt="Foto ampliada" class="foto-full" />
                            <button class="modal-close-btn" (click)="closeModal()" aria-label="Cerrar">
                              <i style="font-size: 50px;" class='bx bx-x'></i>
                            </button>
                          </div>
                        </div>
          
                        <ng-container *ngSwitchCase="'textbox_time'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                              <label for="{{form_elem.label}}"
                                [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-4 col-form-label' : 'col-md-3 col-form-label'">{{form_elem.title}}
                                <span *ngIf="form_elem.validators.required">(*)</span>
                              </label>
                              <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-12' : 'col-sm-9'">
                                <input type="time" class="form-control" name="{{form_elem.label}}"
                                  placeholder="{{form_elem.placeholder}}" formControlName="{{form_elem.label}}"
                                  (change)="Select_ocultar(form_elem)"
                                  [readonly]="form_elem.disabled=='S' || form_elem.A04MOD == 'N'">
                                <div *ngIf="form_elem.validators.required">
                                  <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                                    {{form_elem.validators.msg_validacion}}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'qr'">
                          <div [ngClass]="clasesElemento(form_elem)">
                            <div class="mb-2 row" id="ms_{{this.FormID}}{{form_elem.label}}">
                              <label for="{{form_elem.label}}"
                                [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-4 col-form-label' : 'col-md-3 col-form-label'">{{form_elem.title}}
                                <span *ngIf="form_elem.validators.required">(*)</span>
                              </label>
                              <div [ngClass]="form_elem.SYS03TXT == 'S' ? 'col-md-12' : 'col-sm-9'">
                                <div style="position: relative; display: inline-block;">
                                  <input type="hidden" class="form-control" id="{{FormID}}{{form_elem.label}}"
                                    name="{{form_elem.label}}"
                                    placeholder="{{form_elem.placeholder}}"
                                    [readonly]="form_elem.disabled=='S' || form_elem.A04MOD == 'N'"
                                    formControlName="{{form_elem.label}}">
                                    <qrcode *ngIf="myFormGroup.get(form_elem.label)?.value" [qrdata]="myFormGroup.get(form_elem.label)?.value" [width]="200" [errorCorrectionLevel]="'M'"></qrcode>                                  
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
          
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-container>   
    </div> 

    <div style='margin-top:20px'>
      <button *ngIf="blnMostrarBusqueda" type='submit' class="btn btn-info btn-label waves-light">
        <i class="bx bx-search-alt-2 label-icon"></i>
        Buscar
      </button>
    </div>

  </form>

</div>
<!-- div inicial del campo -->



<div id="buttons" *ngIf="this.ToolbarMS">
  <!-- BEGIN Toolbar -->
  <div class="row">
    <div class="col-12">
      <div class="navbar-header toolbar">
        <div class="d-flex">
          <div class="d-flex">
            <div>
              <label>[{{this.SYS02CON}}]</label>
            </div>
          </div>
        </div>
        <div class="d-flex">
          <div class="d-inline-block bloque" *ngFor="let boton of this.ToolbarMS">
            <button type="button" title="{{boton.Tooltip}}" Style="margin-left: 10px" id="campo_{{boton.Evento}}" *ngIf="boton.Evento != 'IMPRIMIR' && boton.Evento != 'ABRIR_MS'"
              name="{{boton.Evento}}"
              (click)="EventoClickMS($event, boton.URL, boton.Evento, 'campo2_'+boton.Evento, boton, '')"
              class="btn blanco  btn-label waves-light" [ngStyle]="{'background-color': boton.class }">
              <i class="fas {{ boton.icono}} blanco label-icon" style="pointer-events:none ;"></i>
              {{boton.boton}}
            </button>

            <div ngbDropdown class="d-inline-block" *ngIf="boton.Evento == 'IMPRIMIR' && boton.Evento != 'ABRIR_MS'">
              <button type="button" title="{{boton.Tooltip}}" Style="margin-left: 10px" id="campo_{{boton.Evento}}" 
                name="{{boton.Evento}}"
                ngbDropdownToggle
                class="btn blanco  btn-label waves-light" [ngStyle]="{'background-color': boton.class }">
                <i class="fas {{ boton.icono}} blanco label-icon" style="pointer-events:none ;"></i>
                {{boton.boton}}
              </button>
              <div ngbDropdownMenu>
              <ng-container>
                  <button ngbDropdownItem id="PDF" name="PDF" (click)="EventoClickMS($event, boton.URL, boton.Evento, 'campo2_'+boton.Evento, boton, 'PDF')">
                      <i class="fas fa-file-pdf label-icon operacion-pdf" >
                      </i> 
                      Ver en PDF
                  </button>
                  <button ngbDropdownItem id="EXCEL" name="EXCEL" (click)="EventoClickMS($event, boton.URL, boton.Evento, 'campo2_'+boton.Evento, boton, 'XLS')">
                      <i class="fas fa-file-excel label-icon operacion-excel" >
                      </i> 
                      Descargar Excel
                  </button>
              </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END Toolbar -->
  <div class="card" *ngIf="dropzonevisible">
    <div class="card-body row ">
      <app-documentos [WsLlaves]=copiallaves></app-documentos>
    </div>
  </div>

</div> <!-- END BUTTONS -->
<app-scroll-to-top>
</app-scroll-to-top>
